import { Grid, GridItem, Text, useDisclosure } from '@chakra-ui/react';
import React, { useContext, useState } from 'react';
import context from '../context';
import {
  ASPECTO_DESTAQUE,
  ASPECTO_QUADRADO,
} from '../../MobileComponents/vitrines/constantes';
import Banner from './Banner';
import BannerForm from './BannerForm';

// Os dois tipos usam os mesmos 4 itens: trocar o Tipo só redesenha a grade.
const ASPECTO_GRADE = 1;

interface Props {
  /** Tipo em edicao no formulario. Sem ele, cai no tipo salvo do grupo. */
  type?: string;
}

const Banners: React.FC<Props> = ({ type }) => {
  const { pageGroup } = useContext(context);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [clickedBanner, setClickedBanner] = useState<any | undefined>(
    undefined,
  );

  const itens = pageGroup?.items ?? [];
  const ehGrade = (type ?? pageGroup?.type) === 'grade_2x2';

  const abrir = (banner: any) => {
    setClickedBanner(banner);
    onOpen();
  };

  const fechar = () => {
    setClickedBanner(undefined);
    onClose();
  };

  const slots = ehGrade
    ? [0, 1, 2, 3].map(i => ({
        index: i,
        papel: `Quadrado ${i + 1}`,
        aspectRatio: ASPECTO_GRADE,
        colSpan: 1,
      }))
    : [
        {
          index: 0,
          papel: 'Destaque',
          aspectRatio: ASPECTO_DESTAQUE,
          colSpan: 3,
        },
        {
          index: 1,
          papel: 'Quadrado 1',
          aspectRatio: ASPECTO_QUADRADO,
          colSpan: 1,
        },
        {
          index: 2,
          papel: 'Quadrado 2',
          aspectRatio: ASPECTO_QUADRADO,
          colSpan: 1,
        },
        {
          index: 3,
          papel: 'Quadrado 3',
          aspectRatio: ASPECTO_QUADRADO,
          colSpan: 1,
        },
      ];

  return (
    <>
      <Text fontSize="sm" color="gray.600" mb={3}>
        {ehGrade
          ? 'Tipo 2: quatro banners em duas colunas.'
          : 'Tipo 1: um banner em destaque e três quadrados abaixo.'}
      </Text>

      <Text fontSize="xs" color="gray.500" mb={1}>
        Os banners são preenchidos em ordem: só o próximo espaço vazio fica
        disponível.
      </Text>

      {/* maxW: sem ele os slots esticam até a largura do modal */}
      <Grid
        templateColumns={ehGrade ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)'}
        gap={4}
        mt={2}
        maxW="340px"
      >
        {slots.map(slot => (
          <GridItem key={slot.index} colSpan={slot.colSpan}>
            <Banner
              banner={itens[slot.index]}
              index={slot.index}
              papel={slot.papel}
              aspectRatio={slot.aspectRatio}
              onClick={abrir}
              desabilitado={slot.index > itens.length}
            />
          </GridItem>
        ))}
      </Grid>

      <BannerForm
        isOpen={isOpen}
        banner={clickedBanner}
        onClose={fechar}
        onSaved={fechar}
      />
    </>
  );
};

export default Banners;
